import state from './modulePaymentListState.js'
import mutations from './modulePaymentListMutations.js'
import actions from './modulePaymentListActions.js'
import getters from './modulePaymentListGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
